<template>
    <div class="successNo">
        <em class="icon"></em>
        <p>提交成功</p>
        <div class="btn_return"><a :href="infoUrl">继续浏览信息</a></div>
    </div>
</template>

<script>
    import axios from 'axios'
    import {getReasonList} from '../../components/api/request.js'
   export default {
        data () {
            return {
                infoUrl : this.$route.query.infourl
            }
        }
    }
</script>

<style lang="less">
    body{
        background-color: #fff;
        .successNo{
            width: 100%;
            height: 100%;
            background-color: #fff;
            .icon{
                display: block;
                margin: 30% auto 0;
                width: 50px;
                height: 50px;
                background-image: url(//img.58cdn.com.cn/resource/xxzl/voteCpnfigure_hy/img/icon_success.png);
                background-size: 50px;
                background-repeat: no-repeat;
            }
            p{
                margin-top: 15px;
                text-align: center;
                font-size: 21px;
                color: #333
            }
            .mess{
                font-size: 15px;
            }
            .btn_return{
                margin: 50px auto;
                float: inherit;
                width: 150px;
                height: 45px;
                line-height: 45px;
                text-align: center;
                background: #fff;
                border: 1px solid #EAEAEA;
                border-radius: 2px;
                font-size: 15px;
                color: #333333;
                a{
                    color: #333
                }
            }
        }
    }  
</style>


// WEBPACK FOOTER //
// src/page/SuccessNoLogin/SuccessNoLogin.vue